export const closeModal = () => {
    document.body.style.overflowY = 'unset';
    document.getElementsByClassName("overlay")[0].style.visibility = "hidden"
    document.getElementsByClassName("overlay")[0].style.opacity = 0
    document.getElementById("navigationBar").style.display = "block"
}